import { ConfigurationSettings } from "models/configuration-settings";
import { clients } from "lib/https";
import { TranscribeAudioToTextResponse } from "../types/model.types";

export const transcribeAudioToText = async (audioBlob: Blob, configurationSettings: ConfigurationSettings): Promise<TranscribeAudioToTextResponse> => {
    const formData = new FormData();
    formData.append('audioFile', audioBlob, 'audio.wav');

    const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.taskforce.transcribe}`;

    return clients.post<TranscribeAudioToTextResponse>(url, configurationSettings.blocksKey, formData, {}, true);
}
